// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__4zrTM","alarm_modal":"modal_alarm_modal__3njVh","alarm_modal_lg":"modal_alarm_modal_lg__2BUeC","alarm_modal_bg":"modal_alarm_modal_bg__2ot2O"};